export interface PreferenceToggleProps {
  label: string;
  description: string;
  checked: boolean;
  disabled: boolean;
  onChange: () => void;
}

/**
 * Reusable toggle component for user preferences
 * Displays a label, description, and a switch-style toggle button
 */
export function PreferenceToggle({
  label,
  description,
  checked,
  disabled,
  onChange,
}: PreferenceToggleProps) {
  return (
    <label className="flex items-start justify-between cursor-pointer">
      <div className="flex-1 pr-4">
        <span className="text-large text-slate-50 font-medium block">
          {label}
        </span>
        <span className="text-body text-slate-400">{description}</span>
      </div>
      <button
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        onClick={onChange}
        className={`relative inline-flex h-6 w-11 flex-shrink-0 rounded-full transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-purple-300 focus:ring-offset-2 focus:ring-offset-slate-700 ${
          checked ? 'bg-purple-400' : 'bg-slate-500'
        } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
      >
        <span
          className={`inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
            checked ? 'translate-x-5' : 'translate-x-0.5'
          } mt-0.5`}
        />
      </button>
    </label>
  );
}
